import React, { Fragment, useEffect, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Avatar, { AvatarParams, AvatarSize } from './Avatar';

export interface AvatarGroupParams {
  avatars: AvatarParams[];
  groupSize: AvatarGroupSize;
  groupStyle: AvatarGroupStyle;
  maxAvatarsPerGroup?: number;
  hasTooltip?: boolean;
}

export enum AvatarGroupStyle {
  STACKED = 'stacked',
  DEFAULT = 'default',
}

export enum AvatarGroupSize {
  DEFAULT = AvatarSize.SMALL,
  MINIMIZED = AvatarSize.EXTRA_SMALL,
}

const getAvatarSize = (avatarGroupSize: AvatarGroupSize): AvatarSize => {
  return avatarGroupSize as unknown as AvatarSize;
};

const AvatarGroup: React.FC<AvatarGroupParams> = ({
  avatars,
  groupStyle,
  groupSize,
  maxAvatarsPerGroup = 5,
  hasTooltip,
}) => {
  const [classStyles, setClassStyles] = useState({
    parentStyle: '',
    childStyle: '',
    tooltipStyle: '',
  });
  const [avatarGroupSize, setAvatarGroupSize] =
    useState<AvatarGroupSize>(groupSize);

  useEffect(() => {
    if (groupStyle === 'stacked') {
      setClassStyles({
        parentStyle: 'stacked-avatars-group',
        childStyle: 'stacked-avatar avatar-tooltip-click',
        tooltipStyle: 'stacked-avatar-tooltip',
      });
      setAvatarGroupSize(AvatarGroupSize.DEFAULT);
    } else {
      setClassStyles({
        parentStyle: 'default-avatars-group',
        childStyle: 'default-avatar avatar-tooltip-click',
        tooltipStyle: 'avatar-tooltip',
      });
      setAvatarGroupSize(groupSize);
    }
  }, [groupStyle, groupSize]);

  return (
    <div className={classStyles.parentStyle}>
      {avatars.slice(0, maxAvatarsPerGroup).map((avatar: AvatarParams) => (
        <span className={`${classStyles.childStyle}`} key={avatar?.id}>
          <Avatar
            {...avatar}
            size={getAvatarSize(avatarGroupSize)}
            tooltipClass={classStyles.tooltipStyle}
            hasTooltip={hasTooltip}
          />
        </span>
      ))}
      {avatars.length > maxAvatarsPerGroup && groupStyle === 'stacked' && (
        <Fragment>
          <span className="default-avatar">
            <OverlayTrigger
              placement="bottom-start"
              rootClose={true}
              trigger="click"
              overlay={
                <Popover
                  id="popover-contained"
                  placement="bottom-end"
                  className="avatars-popover"
                >
                  <Popover.Body>
                    {avatars
                      .slice(maxAvatarsPerGroup)
                      .map((avatar: AvatarParams) => (
                        <div
                          className="d-flex flex-row align-items-center avatar-popover-container"
                          key={avatar?.id}
                        >
                          <span className="avatar-popover-img">
                            <Avatar
                              {...avatar}
                              hasTooltip={false}
                              size={getAvatarSize(avatarGroupSize)}
                            />
                          </span>
                          <span>{avatar.name}</span>
                        </div>
                      ))}
                  </Popover.Body>
                </Popover>
              }
            >
              <span className="stacked-counter">
                +{avatars.length - maxAvatarsPerGroup}
              </span>
            </OverlayTrigger>
          </span>
        </Fragment>
      )}
    </div>
  );
};

export default AvatarGroup;
